import { configureStore } from '@reduxjs/toolkit'

// TODO: Add actual reducers here
const store = configureStore({
  reducer: {
    // auth: authReducer,
    // cases: casesReducer,
    // images: imagesReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export { store }